__turbopack_context__.v({
  "wrapper": "ArticleBlocks-module-scss-module__ovuEGa__wrapper",
});
